import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { createSecurityGroup, fetchSecurityGroup } from '../../../api/SecurityGroupApi';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modes, Statuses } from '../../../constants/Enums';
import Routes from '../../../constants/Routes';
import { overlayDivStyles } from '../../common/styles/LoadingOverlay.css';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';
import SecurityGroupForm from '../SecurityGroupForm';
import { addApp, removeApp, updateSecurityGroup } from '../../../actions/SecurityGroupActions';

class CopySecurityGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            securityGroup: {},
            showConfirmModal: false,
            error: {},
            showError: false,
            formErrors: [],
            errorMessage: 'An unknown  error has occurred',
            roleType: null,
            apps: [],
            permissions: {},
            operationStatus: Statuses.NOT_STARTED
        };
    }

    setCopySecurityGroup = (securityGroup) => {
        if (securityGroup) {
            securityGroup.name = '';
            securityGroup.description = '';
            securityGroup.users = [];
            delete securityGroup.id;
            if (securityGroup.roleType)
                delete securityGroup.roleType;
            this.props.updateSecurityGroup(securityGroup);
            this.setState({ securityGroup });
        }
    };

    setApps = (appId) => {
        let securityGroup = this.state.securityGroup;
        if (securityGroup.appIds && securityGroup.appIds.includes(appId)) {
            this.props.removeApp(appId);
            this.props.updateSecurityGroup(securityGroup);
        } else {
            this.props.addApp(appId);
        }
    };


    handleSubmit = (e) => {
        e.preventDefault();
        this.setConfirmModalOpen(true);
    };

    submitForm = () => {
        let securityGroup = this.state.securityGroup;
        this.props.createSecurityGroup(securityGroup);
        this.setConfirmModalOpen(false);
    };


    setConfirmModalOpen = (isOpen) => {
        this.setState({ showConfirmModal: isOpen });
    };

    componentDidMount() {
        let { securityGroup } = this.props;
        if (securityGroup != null && Object.keys(securityGroup).length > 0 && securityGroup.permissions) {
            this.setCopySecurityGroup(securityGroup);
        }
    }


    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.securityGroup && nextProps.securityGroup !== this.state.securityGroup) {
            this.setState({ securityGroup: nextProps.securityGroup });
        }
        if (nextProps.activeApps !== this.props.activeApps) {
            this.setState({
                activeApps: { ...nextProps.activeApps }
            });
        }
        if (nextProps.form && nextProps.form.syncErrors !== this.state.formErrors) {
            this.setState({ formErrors: nextProps.form.syncErrors });
        }
        if (nextProps.permissions !== this.state.permissions && nextProps.permissions != null) {
            this.setState({ permissions: nextProps.permissions });
        }
        if (nextProps.apps !== this.state.apps) {
            this.setState({ apps: nextProps.apps });
        }
        if (nextProps.users !== this.state.users) {
            this.setState({ users: nextProps.users });
        }
        if (nextProps.operationStatus !== this.state.operationStatus)
            this.setState({ operationStatus: nextProps.operationStatus });
    }

    componentDidUpdate(_prevProps, prevState) {
        if (prevState.operationStatus !== this.state.operationStatus) {
            if (this.state.operationStatus === Statuses.SUCCESS)
                this.props.redirect(Routes.SECURITY_GROUPS);
        }
        if (prevState.securityGroup !== this.state.securityGroup) {
            if (Object.keys(prevState.securityGroup).length === 0) {
                if (this.state.securityGroup && this.state.securityGroup.permissions != null) {
                    this.setCopySecurityGroup(this.state.securityGroup);
                }
            }
        }
    }

    shouldDisplay = () => {
        return Object.keys(this.state.securityGroup).length > 0 &&
            this.state.securityGroup.permissions &&
            this.state.users &&
            this.state.apps &&
            this.state.permissions;
    };

    render() {
        if (this.shouldDisplay()) {
            return (
                <SecurityGroupForm toggleSecurityModal={this.props.toggleSecurityModal}
                                   isFetching={this.props.isFetching}
                                   showError={this.state.showError}
                                   mode={Modes.COPY} apps={this.state.apps}
                                   setConfirmModalOpen={this.setConfirmModalOpen}
                                   submitForm={this.submitForm}
                                   showConfirmModal={this.state.showConfirmModal} handleSubmit={this.handleSubmit}
                                   errorMessage={this.props.errorMessage}
                                   buttonIsDisabled={() => {
                                       return this.state.formErrors != null;
                                   }} cancel={() => this.props.redirect(Routes.SECURITY_GROUPS)}
                                   permissions={this.state.permissions}
                                   isModalOpen={this.props.isModalOpen}
                                   disabled={false} roleType={this.state.roleType} addApp={this.setApps}
                                   removeApp={this.setApps} />
            );
        } else return (
            <div className={'content'} style={overlayDivStyles}>
                <LoadingOverlay loading={true}>

                </LoadingOverlay>
            </div>
        )
    }
}

CopySecurityGroup.propTypes = {
    toggleSecurityModal: PropTypes.func.isRequired,
    redirect: PropTypes.func.isRequired
};


function mapStateToProps(state) {
    return {
        form: state.form.createSecurityGroup,
        permissions: state.securityGroup.permissions,
        securityGroup: state.securityGroup.securityGroup,
        isModalOpen: state.securityGroup.isModalOpen,
        users: state.authenticationReducer.users,
        apps: state.securityGroup.apps,
        error: state.securityGroup.err,
        isFetching: state.securityGroup.isFetching,
        activeApps: state.securityGroup.activeApps,
        operationStatus: state.securityGroup.operationStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchSecurityGroup,
        updateSecurityGroup, createSecurityGroup, addApp, removeApp
    }, dispatch);
}

CopySecurityGroup.propTypes = {
    updateSecurityGroup: PropTypes.func,
    removeApp: PropTypes.func,
    addApp: PropTypes.func,
    errorMessage: PropTypes.string,
    createSecurityGroup: PropTypes.func,
    isFetching: PropTypes.bool,
    form: PropTypes.object,
    permissions: PropTypes.array,
    securityGroup: PropTypes.object,
    isModalOpen: PropTypes.bool,
    users: PropTypes.array,
    apps: PropTypes.array,
    error: PropTypes.object,
    activeApps: PropTypes.object,
    operationStatus: PropTypes.number
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CopySecurityGroup));